import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

type GetBusinessCreatedCouponsParams = {
  page?: number;
};

type BusinessCreatedCoupon = Record<string, any>;

/**
 * Fetch coupons created by the currently logged-in business user.
 * Backend: GET /api/coupon/businessCoupons/getCreatedCoupons
 */
export const GetBusinessCreatedCouponsAPI = async ({
  page,
}: GetBusinessCreatedCouponsParams = {}): Promise<
  ServiceResponse<BusinessCreatedCoupon[]>
> => {
  const { business } = store.getState().auth as any;
  try {
    const resp = (await service.call(
      "GET",
      "api/coupon/businessCoupons/getCreatedCoupons",
      {
        user_id: business?.user_id,
        ...(page !== undefined ? { page } : {}),
      },
    )) as ServiceResponse<BusinessCreatedCoupon[]>;
    return resp;
  } catch (err) {
    console.error(`GetBusinessCreatedCouponsAPI ${err}`);
    return { status: -1, error: err };
  }
};
